import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Welcome' },
    { path: '/the-adventure', label: 'The Adventure' },
    { path: '/our-pilots', label: 'Our Pilots' },
    { path: '/our-balloons', label: 'Our Balloons' },
    { path: '/our-history', label: 'Our History' },
    { path: '/reviews-gallery', label: 'Reviews & Gallery' },
    { path: '/faqs', label: 'FAQs' },
    { path: '/news', label: 'News' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#ee6a1f] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 sm:px-8 lg:px-12">
        <div className="flex justify-between items-center h-32">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://ik.imagekit.io/hqhiltiie/Balloon/ballon%20rides%20v2.svg" 
              alt="SKYHIGH Adventures" 
              className="h-20 w-auto md:h-24"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-4 ml-auto pl-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-2 py-1.5 text-sm font-semibold transition-colors ${
                  location.pathname === link.path
                    ? 'text-[#EE6A1F]'
                    : 'text-white hover:text-[#EE6A1F]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/view-flights"
              className="px-5 py-2.5 rounded-full bg-white text-[#EE6A1F] font-semibold shadow-lg transition-transform hover:scale-105"
            >
              View Flights
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-gray-900/95 border-t">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-sm font-semibold transition-colors ${
                  location.pathname === link.path
                    ? 'text-[#EE6A1F]'
                    : 'text-white hover:text-[#EE6A1F]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/view-flights"
              onClick={() => setIsMobileMenuOpen(false)}
              className="inline-flex w-full justify-center rounded-full bg-white px-6 py-3 text-base font-semibold text-[#EE6A1F] shadow-lg transition-transform hover:scale-105"
            >
              View Flights
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
